import React from 'react';

var SignUp = React.createClass({
  getInitialState: function(){
    return {
      name:"",
      username: "",
      password: "",
      confirmPassword: "",
      email: "",
      passwordErrMsg: "",
      userNameclass: "",
      userNameErrMsg: "",
      nameClass: "",
      passwordMatch: "",
      emailclass: "",
      passwordValid: "",
      confirmPassErrMsg: ""
    }
  },
  componentWillReceiveProps: function(nextProps){
    if(nextProps.signUpError){
      this.setState({userNameclass: "field__error--input", userNameErrMsg: "Error: This Username already exists."})
    }else{
      this.setState({userNameclass: ""});
    }
  },
  NameChange : function (e) {
    this.setState({name: e.target.value, nameClass: ""});
    //this.props.clearLoginErrors();
  },
  userNameChange: function(e){
    this.setState({username: e.target.value, userNameclass: "", userNameErrMsg: ""});
    this.props.clearLoginErrors();
  },
  passwordChange: function(e){
    this.setState({password: e.target.value, passwordValid: "", passwordErrMsg: ""});
  },
  confirmChange: function(e){
    this.setState({confirmPassword: e.target.value, passwordMatch: "", confirmPassErrMsg: ""});
  },
  emailChange: function(e){
    this.setState({email: e.target.value, emailclass: ""});
  },
  handleClick: function(){
    var errorFlag =  false; 
    /*  validations */
    if (this.state.username.trim() == "") {
      errorFlag =  true; 
      this.setState({userNameclass: "field__error--input", userNameErrMsg: "Error: Please enter Username."});
    } else if(/^\s+/.test(this.state.username)){
      errorFlag =  true; 
      this.setState({userNameclass: "", userNameErrMsg: "Error: Please enter a valid Username."});
    }

    // if (this.state.name == "") {
    //   errorFlag =  true; 
    //   this.setState({nameClass: "field__error--input"})
    // }
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(this.state.email.trim() !== ""){
      if(!re.test(this.state.email)){
        errorFlag =  true; 
        this.setState({emailclass: "field__error--input"});
      }
    }

    if(this.state.password.length >= 8){
      if (!(/\d/.test(this.state.password) && /[a-zA-Z]/.test(this.state.password))) {
        errorFlag =  true; 
        this.setState({passwordValid: "field__error--input"})
        this.setState({passwordErrMsg: "Error: Eight characters min, with at least one letter and one number."});
      }
    } else if(this.state.password.trim() === ""){
      errorFlag =  true; 
      this.setState({passwordValid: "field__error--input"});
      this.setState({passwordErrMsg: "Error: Please enter Password."});
    } else{
      errorFlag =  true; 
      this.setState({passwordValid: "field__error--input"});
      this.setState({passwordErrMsg: "Error: Eight characters min, with at least one letter and one number."});
    }
    
    // if(!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(this.state.password)){
    //   errorFlag =  true; 
    //   this.setState({passwordValid: "form__wrap__field error_field"})
    // }
    if(this.state.confirmPassword.trim() === ""){
      errorFlag =  true; 
      this.setState({passwordMatch: "field__error--input", confirmPassErrMsg: "Error: You can't leave this empty"});
    } else if(this.state.password !== this.state.confirmPassword){
      errorFlag =  true; 
      this.setState({passwordMatch: "field__error--input", confirmPassErrMsg: "Error: Confirm password entry does not match Password."});
    }  

    if(!errorFlag) {
      this.props.signUp (false, this.state.name, this.state.username, this.state.password, this.state.email);
    }
    
  },

  render: function(){
    return(
       <div className="form__wrap--col form__wrap--col-right">
        <div className="form__row clearfix">
          <h4 className="modal__header--title big"><i className="fa fa-chevron-circle-right"></i> Don’t Have a Blended Account?</h4>
          <p className="top--ten">Having an account lets you share, deploy and backup your website designs.</p>
        </div>
        <div className="form__row clearfix">
          <div className="form__cell">
            {this.state.userNameErrMsg != "" ?
            <p className="field__error--text">{this.state.userNameErrMsg}</p> : null }
            <div className={this.state.userNameclass}>
              <input type="text" onChange = {this.userNameChange} value={this.state.username} placeholder="Username"/>
            </div>
          </div>
        </div>
        <div className="form__row clearfix">
          <div className="form__cell">
            {this.state.emailclass != "" ?
            <p className="field__error--text">Error: You have entered an invalid email address.</p> : null }
            <div className={this.state.emailclass}>
              <input type="text"  onChange = {this.emailChange} value={this.state.email} placeholder="Email (Optional)"/>
            </div>
          </div>
        </div>
        <div className="form__row clearfix">
          {this.state.passwordErrMsg === "" ?
          <p className="small">Eight characters min, with at least one letter and one number.</p> : null }
          <div className="form__cell">
            { this.state.passwordErrMsg != "" ?
            <p className="field__error--text">{this.state.passwordErrMsg}</p> : null }
            <div className={this.state.passwordValid}>
              <input type="password" onChange = {this.passwordChange} value={this.state.password} placeholder="Password"/>
            </div>
          </div>
        </div>
        <div className="form__row clearfix">
          <div className="form__cell">
           {this.state.confirmPassErrMsg != "" ? 
            <p className="field__error--text">{this.state.confirmPassErrMsg}</p> : null }
            <div className={this.state.passwordMatch}>
              <input type="password" onChange = {this.confirmChange} value={this.state.confirmPassword} placeholder="Confirm password"/>
            </div>
          </div>
        </div>
        
        <div className="form__row last clearfix">
        <div className="form__cell">
          <button className="btn__lg bg-dark sign_up_btn" onClick= {this.handleClick}><span>Sign Up</span></button>
          <p className="small top--ten">Your privacy is very important to us. Your email address will never be shared and your information will be kept confidential. Read our <a href="#">Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
    );
  }
});


export {SignUp}


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/SignUpPopup/SignUp.jsx
 **/